import React from "react";
import { Select, Checkbox } from "antd";
import _ from "lodash";
import moment from "moment";

const Option = Select.Option;

class CertificateList extends React.Component {
  state = {
    certificate: null
  };
  componentDidMount() {
    const { serialValue, certificates } = this.props;
    const certificate = _.find(certificates, ["serial", serialValue]);

    this.setState(() => ({ certificate }));
  }

  handleChange = value => {
    const { certificates, fieldName } = this.props;
    const certificate = _.find(certificates, ["serial", value]);
    this.setState({ certificate }, () => {
      this.props.handleUpload(fieldName, certificate.serial);
      this.props.handleUpdate();
    });
  };

  onChange = () => {
    this.props.renderForm();
  };

  render() {
    const { serialValue, certificates } = this.props;
    const { certificate } = this.state;
    return (
      <div style={{ marginBottom: "2rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <Select
            showSearch
            style={{ width: 400 }}
            placeholder="Selecciona un certificado"
            onChange={this.handleChange}
            defaultValue={serialValue}
          >
            {certificates.map(certificate => {
              const { serial, rfc } = certificate;
              return (
                <Option key={serial} value={serial}>
                  RFC: {rfc}
                </Option>
              );
            })}
          </Select>
          <Checkbox onChange={this.onChange}>Añadir certificado</Checkbox>
        </div>
        {certificate && (
          <div style={{ padding: "2rem 0" }}>
            <h3>Certificado para {certificate.rfc}</h3>
            <p>Serial {certificate.serial}</p>
            <p>Vigencia {moment(certificate.endDate).format("LLL")}</p>
          </div>
        )}
      </div>
    );
  }
}

export default CertificateList;



// WEBPACK FOOTER //
// ./src/Components/Orders/CertificateList.js